import { render } from "./TraitRanksApesDisclaimer.vue?vue&type=template&id=b8015512"
import script from "./TraitRanksApesDisclaimer.vue?vue&type=script&lang=js"
export * from "./TraitRanksApesDisclaimer.vue?vue&type=script&lang=js"

import "./TraitRanksApesDisclaimer.vue?vue&type=style&index=0&id=b8015512&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__